import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import Page from 'views/Page.vue'
import Post from 'views/Post.vue'

Vue.use(Router)
Vue.use(Meta)

export function createRouter () {
  return new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/',
        name: 'home',
        component: Page,
        // eslint-disable-next-line
        props: (route) => ({ slug: 'home' })
      },
      {
        path: '/:page',
        name: 'page',
        component: Page,
        props: (route) => ({ slug: route.params.page })
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "page" */ 'views/Page.vue')
      },
      {
        path: '/:year(\\d+)/:month(\\d+)/:day(\\d+)/:post',
        name: 'post',
        component: Post,
        props: (route) => ({ 
          slug: route.params.post,
          year: route.params.year,
          month: route.params.month,
          day: route.params.day
        })
      }
    ]
  })
}
